/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Result of the soft (provider) eligibility check -- whether the user's state + payer is
 * supported by Bridge with at least one credentialed provider available
 */
export interface ProviderEligibilityResponse {
  /** True if at least one service type is supported with an available provider */
  eligible: boolean;
}
